<template>
  <teleport to="body">
    <transition name="backdrop" appear>
      <div id="base-spinner" v-if="open"></div>
    </transition>
  </teleport>
</template>

<script>
export default {
  props: {
    open: {
      type: Boolean,
      required: true,
      default: false
    }
  },
};
</script>

<style scoped>

#base-spinner {
    position:fixed;
    width:100%;
    left:0;right:0;top:0;bottom:0;
    /* background-color: rgba(51, 51, 51, 0.8); */
    opacity: 0.6;
    z-index: 9999;
    /* display: none; */
}

@-webkit-keyframes spin {
	from {-webkit-transform:rotate(0deg);}
	to {-webkit-transform:rotate(360deg);}
}

@keyframes spin {
	from {transform:rotate(0deg);}
	to {transform:rotate(360deg);}
}

#base-spinner::after {
    content:'';
    display:block;
    position:absolute;
    left:48%;top:40%;
    width:40px;height:40px;
    border-style:solid;
    border-color:#999;
    border-top-color:transparent;
    border-width: 4px;
    border-radius:50%;
    -webkit-animation: spin .8s linear infinite;
    animation: spin .8s linear infinite;
}

.backdrop-enter-active {
  animation: backdrop ease .4s;
}

.backdrop-leave-active {
  animation: backdrop ease .4s reverse;
}

@keyframes backdrop {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 0.6;
  }
}

</style>